import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { map } from 'rxjs/operators';
import { SessionService } from '../services/session.service';
import type { UserSession } from '../types/session';

type EnabledFeature = UserSession['enabledFeatures'][number];

/**
 * Route guard for account feature flags surfaced on the session's `enabledFeatures`.
 * Unflagged accounts are sent back to the budgets page instead of seeing a broken route.
 */
export function featureFlagGuard(feature: EnabledFeature): CanActivateFn {
  return () => {
    const sessionService = inject(SessionService);
    const router = inject(Router);

    return sessionService
      .hasEnabledFeature$(feature)
      .pipe(map(enabled => (enabled ? true : router.createUrlTree(['/budgets']))));
  };
}
